import React, { useRef } from "react";
import "./AboutUs.scss";
import { useInView, motion } from "framer-motion";

const AboutUs = () => {
  const body = useRef(null);
  const isInView = useInView(body, { once: true, margin: "-75%" })

  const animation = {
    initial: { y: "100%" },
    enter: (i: any) => ({ y: "0", transition: { duration: 0.75, ease: [0.33, 1, 0.68, 1], delay: 0.075 * i } })
  }

  const aboutText = [
    "At the heart of our brand lies a philosophy that goes beyond fleeting trends, capturing the ",
    "essence of timeless style and individuality. Each shoes collection is crafted to combine sophistication",
    "versatility, and modern design, allowing  you to step out with confidence and purpose. We believe footwear",
    " should empower and inspire, serving as a canvas for  your personal expression. Our shoes aren’t just",
    "accessories—they’re reflections of a lifestyle that values quality, artistry, and the unique story of each ",
    "individual. Embrace your journey with every step, and let our shoes be part of the story you create.",
  ]

  return (
    <>
      <div className="about_page w-[96%]">
        <div className="about_page_container">
          <section className="lg:text-center sm:text-[25px] text-[18px] font-medium  sm:leading-9  sm:py-[200px] py-[100px]" ref={body}>
            {
              aboutText.map((phrase, index) => {
                return <div key={index} className="sm:my-[0px] my-[10px]">
                  <motion.p custom={index} variants={animation} initial="initial" animate={isInView ? "enter" : ""}>{phrase}</motion.p>
                </div>
              })
            }
          </section> 
        </div>
      </div>

      {/* <section>
        <Reviews />
      </section> */}
    </>
  );
};

export default AboutUs;
